"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Input_1 = __importDefault(require("./Input"));
var Icon_1 = __importDefault(require("./Icon"));
var FileUpload = function (_a) {
    var id = _a.id, classes = _a.classes, _b = _a.component, component = _b === void 0 ? 'span' : _b, _c = _a.color, color = _c === void 0 ? 'primary' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.variant, variant = _e === void 0 ? 'contained' : _e, _f = _a.size, size = _f === void 0 ? 'medium' : _f, _g = _a.disableElevation, disableElevation = _g === void 0 ? true : _g, _h = _a.disableFocusRipple, disableFocusRipple = _h === void 0 ? false : _h, _j = _a.disableRipple, disableRipple = _j === void 0 ? false : _j, endIcon = _a.endIcon, _k = _a.fullWidth, fullWidth = _k === void 0 ? false : _k, href = _a.href, startIcon = _a.startIcon, _l = _a.label, label = _l === void 0 ? 'Select file' : _l, accept = _a.accept, getRef = _a.getRef, onChange = _a.onChange, _m = _a.showControlIcon, showControlIcon = _m === void 0 ? true : _m, _o = _a.showSelectedFileName, showSelectedFileName = _o === void 0 ? true : _o, _p = _a.multiple, multiple = _p === void 0 ? false : _p;
    var inputRef = (0, react_1.useRef)(null);
    var _q = (0, react_1.useState)(''), fileName = _q[0], setFileName = _q[1];
    (0, react_1.useEffect)(function () {
        if (getRef && inputRef)
            getRef(inputRef.current);
    }, [getRef, inputRef]);
    var hasFile = !!(fileName && fileName.length);
    var innerLabel = hasFile && showSelectedFileName ? fileName : label;
    return (react_1.default.createElement("label", { htmlFor: id },
        react_1.default.createElement(Button_1.default, { classes: classes, component: component, color: color, disabled: disabled, variant: variant, size: size, disableElevation: disableElevation, disableFocusRipple: disableFocusRipple, disableRipple: disableRipple, endIcon: endIcon, fullWidth: fullWidth, href: href, startIcon: startIcon },
            innerLabel,
            react_1.default.createElement(Icon_1.default, { hasFile: hasFile, inputRef: inputRef, setFileName: setFileName, showControlIcon: showControlIcon }),
            react_1.default.createElement(Input_1.default, { id: id, setFileName: setFileName, accept: accept, onChange: onChange, inputRef: inputRef, label: label, multiple: multiple }))));
};
exports.default = FileUpload;
